<template>
  <section class="content checkout-content wp_AllPageMarginTop wp_MarginBottomAllPage">
    <div
      class="col-12 col-md-8 px-4 mx-auto mt-5 mt-md-0 pt-3"
      style="background-color: white;"
    >
      <div class="row pr-0 mr-0">
        <div class="col-12 pr-0 mr-0">
          <h3 id="rate-product-head"
														data-test="orderRatingHeading">
            <b id="rate-product-head1"
															data-test="orderRatingHeadingBold">
              Rate this Product
            </b>
          </h3>
        </div>
        <div class="col-4 col-md-3 col-lg-2 ">
          <div class="tracker-left-img">
            <img
              v-if="orders.product_image"
              :src="orders.product_image"
              :alt="orders.product_name"
              :id="'rate-pdt-img-'+orders.product_name"
              style="width: 6em; height: 6em;object-fit: contain;"
														data-test="orderRatingOrderPdtImg"
            >
            <img
              v-else
              src="/img/icons/noImage.jpg"
              :alt="orders.product_name"
              :id="'rate-pdt-img-'+orders.product_name"
														data-test="orderRatingNoImage"
            >
          </div>
        </div>
        <div class="col-8 col-md-5 col-lg-6   tracker-prdct-name">
          <h5 :id="orders.product_name"
														data-test="orderRatingPdtName">
            {{orders.product_name}}
          </h5>
          <p :id="'rate-pdt-price-'+orders.product_name"
													data-test="orderRatingPdtPrice">
            Price: Rs. {{orders.price | currencyConversion}}
          </p>
        </div>
        <div
          class="col-12 col-md-3 col-lg-4 offset-7
                      offset-md-0 pr-0 prdt-rating-stars pr-0"
          :id="'rate-pdt-rate-'+orders.product_name"
          :data-test="'rate-pdt-rate-'+orders.product_name"
        >
          <star-rating
            v-model="review.rating"
            :show-rating="false"
          >
          </star-rating>
          <span
            style="color: rgb(255,0,0);"
            v-if="ratingError"
												data-test="orderRatingRatingErrorMSg"
												id="orderRatingRatingErrorMSg"
          >
            {{ ratingErrorMessage }}
          </span>
        </div>
        <div class="col-12 pr-0 mr-0">
          <div class="form-group mt-3">
            <input
              type="text"
              class="form-control"
              aria-describedby="helpId"
              placeholder="Title"
              v-model="review.review_title"
              name="reviewTitle"
              v-validate="'required'"
              :class="{ 'is-invalid': errors.has('reviewTitle')}"
              id="review-title"
														data-test="orderRatingTitleInput"
            >
            <span class="invalid-feedback"
																		data-test="orderRatingTitleInputError"
																		id="orderRatingTitleInputError">
              {{ errors.first('reviewTitle') }}
            </span>
            <textarea
              class="form-control mt-2"
              rows="5"
              id="comment"
              v-model="review.review_text"
              name="review"
              v-validate="'required'"
              placeholder="Review"
              :class="{ 'is-invalid': errors.has('review')}"
														data-test="orderRatingReviewInput"
            >
            Review
          </textarea>
            <span class="invalid-feedback"
																		data-test="orderRatingReviewInputError"
																		id="orderRatingReviewInputError">
              {{ errors.first('review') }}
            </span>
            <label
              for="file-upload"
              class="col-12 pt-4 review-label"
														data-test="orderRatingReviewImgLabel"
														id="orderRatingReviewImgLabel"
            >
              Tap to upload Images (you can upload maximum 5 images)
              <input
                type="file"
                multiple
                accept="image/*"
                @change="uploadImages"
                id="file-upload"
                style="display: none"
																data-test="orderRatingReviewImgInput"
              />
            </label>
            <!--<div v-if="review.image_urls" class="row">-->
            <!--<div class="pr-0 mr-0" v-for="images in review.image_urls"-->
            <!--style="border-radius:2px;position: relative;width: 100px;height: 100px">-->
            <!--<span style="position: absolute;top: 0; right: 0">x</span>-->
            <!--<img class="col-3 pr-1 mr-1 mb-4" :src=images style="width: 100%; height: 100%">-->
            <!--</div>-->
            <!--</div>-->
            <div class="review-images-wrapper">
              <div
                class="wp_userReviewImage"
                v-for="(images,index) in review.image_urls"
                :key="index"
              >
                <img
                  :src=images
                  alt="User Review Image"
																		:data-test="'orderRatingReviewImg'+index"
																		:id="'orderRatingReviewImg'+index"
                >
              </div>
            </div>
            <!--<div class="col-12 pr-0 mr-0">-->
            <!--<img  class="col-3 pr-1 mr-1 mb-4"
            v-for="images in imageUrls"
            :src=images
            style="width: 75px; height: 100px">-->
            <!--</div>-->
            <!--<button class="btn btn-primary btn-type-primary mt-2" @click.prevent="upload">-->
            <!--upload-->
            <!--</button>-->
            <button
              class="btn btn-primary btn-type-primary mt-2"
              role="button"
              @click.prevent="reviewProduct()"
              :disabled="(review.review_text === '') ||
                      (review.review_title === '')"
              id="rate-review-btn"
														data-test="orderRatingSubmitBtn"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { customerApi } from '@/services/ApiServices/customerApi'
import { productApi } from '@/services/ApiServices/productApi'
import StarRating from 'vue-star-rating'

export default {
	data () {
		return {
			review: {
				review_title: '',
				review_text: '',
				rating: 0,
				image_urls: [],
				product_id: ''
			},
			orders: Object,
			productId: '',
			ratingError: false,
			ratingErrorMessage: 'Rating is required.',
			images: [],
			selectedImages: [],
			imageUrls: []
		}
	},
	components: {
		StarRating
	},
	beforeMount () {
		customerApi.getReview(this.$route.query.orderProductId)
			.then((res) => {
				this.alreadyReviewed(res.data)
			})
	},
	mounted () {
		if (this.$route.query.orderProductId) {
			this.productId = this.$route.query.orderProductId
			productApi.getProductsByIds([this.productId]).then((res) => {
				if (res.data && res.data[0]) {
					this.orders = res.data[0]
					if (this.orders.product_details && this.orders.product_details.image_URL_1) {
						this.orders.product_image = this.orders.product_details.image_URL_1
					}
					if (this.orders.vendor_product_inventories &&
            this.orders.vendor_product_inventories[0] &&
            this.orders.vendor_product_inventories[0].price) {
						this.orders.price = this.orders.vendor_product_inventories[0].price
					}
				}
			})
		}
	},
	methods: {
		upload () {
			const formData = new FormData()
			for (let i = 0; i < this.selectedImages.length; i++) {
				formData.append('files', this.selectedImages[i])
			}

			customerApi.uploadReviewImages(formData)
				.then((res) => {
					res.data.forEach((url) => {
						if (this.review.image_urls.length < 5) {
							this.review.image_urls.push(url)
						} else {
							this.$toasted.show('You can upload only 5 images.')
						}
					})
				})
				.catch()
		},
		alreadyReviewed (review) {
			if (review && review.review_text) {
				this.review.review_text = review.review_text
			}
			if (review && review.review_title) {
				this.review.review_title = review.review_title
			}
			if (review && review.rating) {
				this.review.rating = review.rating
			}
			if (review && review.image_urls && review.image_urls[0]) {
				this.review.image_urls = review.image_urls
			}
		},
		reviewProduct () {
			if (this.review.rating === 0) {
				this.ratingError = true
				this.$toasted.show(' You should provide rating to submit',
					{ icon: 'exclamation-circle' }
				)
			} else {
				this.review.product_id = this.productId
				customerApi.reviewProduct(this.review)
					.then((res) => {
						if (res.body.message === 'Your review request is waiting for verification') {
							this.$toasted.show('Your review request is waiting for verification',
								{ icon: 'exclamation-circle' }
							)
						}
						this.review.review_title = ''
						this.review.review_text = ''
						this.review.rating = 0
						this.review.image_urls = []
						this.$router.push({
							path: '/product_description',
							query: {
								productId: this.productId,
								productName: this.orders.product_name
							}
						})
					})
					.catch((e) => {
					})
			}
		},
		uploadImages (event) {
			this.selectedImages = []
			const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i
			const imageArray = event.target.files
			if (imageArray.length > 5) {
				this.$toasted.show('You can upload only 5 images.')
			} else {
				for (let i = 0; i < imageArray.length; i++) {
					if (!(allowedExtensions.exec(event.target.files[i].name))) {
						this.selectedImages = []
						this.$toasted.show('Please upload images of type jpg , jpeg ,png.')
					} else {
						this.selectedImages.push(imageArray[i])
					}
				}
				if (this.selectedImages.length !== 0) {
					this.upload()
				}
			}
			// for(let i = 0 ; i< this.selectedImages.length ; i++){
			//     this.imageUrls.push(URL.createObjectURL(this.selectedImages[i]))
			// }
			// for(let i = 0 ; i<5 ; i++){
			//     this.selectedImages.push(event.target.files[i]);
			// }
			// this.$toasted.show('First five images will be uploaded as review images', { theme: 'toasted-primary',
			//     position: 'top-right' });
		}
	}
}
</script>
